import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTwoArrows = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.5918 27.0707L15.0463 21.4141M15.0463 12.9293H31.41H15.0463ZM31.41 12.9293L25.9554 7.27271L31.41 12.9293ZM31.41 12.9293L25.9554 18.5858L31.41 12.9293ZM25.9554 27.0707H9.5918H25.9554ZM9.5918 27.0707L15.0463 32.7272L9.5918 27.0707Z",
		stroke: "#7F8083",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTwoArrows;
